<template>
  <div class="pay-countdown">
    <img class="countdown-icon" :src="countDownIcon" :alt="$t('倒计时')" />
    <div class="wait-statement">
      <div class="countdown-info" v-if="timeOutClose">{{ $t('支付超时已关闭，你可重新下单') }}</div>
      <div class="countdown-info" v-else>
        <span class="countdown-text">{{ $t('待支付') }}</span>
        <template v-if="seconds !== null">
          <span>，&nbsp;</span>
          <span class="countdown-text" v-html="$t('{time}后支付关闭', { time: formattedTime })"></span>
        </template>
      </div>
      <div class="countdown-help">
        <span>{{ $t('支付遇到问题？') }}</span>
        <es-button variant="text" theme="primary" class="customer-support" @click="getCustomerSupport" :loading="loading">
          {{ $t('点击获取客服支持') }}
        </es-button>
      </div>
    </div>
    <saasOrderGuidance :dialogVisible="guidanceVisible" :orderGuidanceData="orderGuidanceData" @handleClose="guidanceVisible = false" />
  </div>
</template>

<script>
import { saasOrderGuidance } from '@esign-saas-component/esign-design-saas'

export default {
  name: 'PayCountDown',
  components: {
    saasOrderGuidance,
  },
  props: {
    // 倒计时总秒数
    seconds: {
      type: [Number, Object],
      default: null, // 默认2小时 = 7200秒
    },
    // 订单是否失效(超时)
    isInvalid: {
      type: Boolean,
      default: false,
    },
    // 订单是否支付完成
    isPaySuccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      remainingSeconds: this.seconds,
      timer: null,
      guidanceVisible: false, // 客服引导弹窗
      orderGuidanceData: {
        qrCodeType: '',
        qrCodeFileUrl: require('@/assets/images/qywx.png'),
      },
    }
  },
  computed: {
    // 倒计时图标
    countDownIcon() {
      return this.timeOutClose ? require('@/assets/icons/fail-close.svg') : require('@/assets/icons/wait.svg')
    },
    // 支付超时已关闭
    timeOutClose() {
      return this.isInvalid || this.remainingSeconds < 0
    },
    formattedTime() {
      if (this.seconds === null) {
        return this.$t('永久有效')
      }
      if (this.remainingSeconds <= 0) {
        return '00:00:00'
      }
      const day = Math.floor(this.remainingSeconds / 86400)
      const hours = Math.floor((this.remainingSeconds - day * 86400) / 3600)
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60)
      const seconds = this.remainingSeconds % 60

      return `${day ? this.$t('{slot1}天', { slot1: day }) : ''}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
  },
  watch: {
    seconds: {
      handler(newVal) {
        this.remainingSeconds = newVal
        if (newVal !== null) {
          this.clearCountdown()
          this.startCountdown()
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.clearCountdown()
  },
  methods: {
    // 重新下单
    reOrder() {
      this.$emit('reOrder')
    },
    getCustomerSupport() {
      this.$emit('reportGetCustomerSupport')
      this.guidanceVisible = true
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--
        } else {
          this.clearCountdown()
        }
      }, 1000)
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pay-countdown {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 18px 24px;
  border-radius: 8px;
}

.countdown-icon {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
.wait-statement {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.countdown-info {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #333;
}

.countdown-text {
  color: #333;
}

/deep/ .countdown-time {
  color: #ff4d4f;
  margin-right: 5px;
}

.countdown-help {
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  .customer-support {
    color: #007aff;
    font-size: 14px;
  }
}

.help-link {
  font-size: 14px;
  color: #1875f0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
.re-order {
  margin-top: 8px;
}
</style>
